import React, {useState} from 'react';

import {Alert, Button, Card, CardContent} from '@design-system';

import {useOnboarding} from '../Onboarding/useOnboarding';
import TransitionTimeline from '../Parent/Transition/TransitionTimeline';
import FindCurrentStageDialog from './FindCurrentStageDialog';
import {RESOURCE_TITLE_CLASSES} from './ProCategories';

const ProTimeline = () => {
  const {onboardingState} = useOnboarding();
  const stages = onboardingState?.stages;
  const [showStageFinder, setShowStageFinder] = useState(false);
  const [stageDates, setStageDates] = useState();
  const [currentStage, setCurrentStage] = useState();

  return (
    <div data-testid="pro-timeline" className="mx-auto max-w-3xl">
      <div className="text-center text-(--compass-on-surface)">
        <h1 className={`mb-4 ${RESOURCE_TITLE_CLASSES}`}>Transition Timeline</h1>
        <p className="m-0 mb-2">
          Compass divides the transition process into several stages, to help parents/carers keep
          track of the main actions as time goes on.
        </p>
        <p className="m-0">
          Click on the stages below to see more information about the key things to think about at
          each stage.
        </p>
      </div>
      <Card className="mx-auto my-8 max-w-xl">
        <CardContent className="flex flex-col items-center gap-4 p-4 text-center">
          <p className="m-0">
            If you know some details about a young person, you can find their current stage by
            pressing the button below
          </p>
          <Button
            type="button"
            className="min-h-11"
            data-testid="find-current-stage-open"
            onClick={() => setShowStageFinder(true)}>
            Find current stage
          </Button>
          {/* Mounted throughout, a polite status, so the result is announced when it
              replaces the hint: an info Alert until then, a success one after. */}
          <Alert
            variant={currentStage ? 'success' : 'info'}
            data-testid="current-stage-result"
            className="my-0 w-full text-left">
            {currentStage ? (
              <>
                Your current stage is: <b>{currentStage.name}</b>
              </>
            ) : (
              'This can help you give them more tailored advice for their situation.'
            )}
          </Alert>
        </CardContent>
      </Card>

      <FindCurrentStageDialog
        open={showStageFinder}
        handleClose={() => setShowStageFinder(false)}
        handleResult={(stageDates, currentStage) => {
          setStageDates(stageDates);
          setCurrentStage(currentStage);
          setShowStageFinder(false);
        }}
      />

      <TransitionTimeline
        stageDates={stageDates ?? stages}
        highlightedStage={currentStage}
        highlightText="Current"
      />
    </div>
  );
};

export default ProTimeline;
